import DataFetcherTemplate from "../hooks/fetchTemplate";
import Block3Columns from "../components/Block3Columns";
import Block4Columns from "../components/Block4ColumnsText";
import BlockBackgroundImage from "../components/BlockBackgroundImage";
import BlockImageCabecera from "../components/BlockImageCabecera";
import ImageGallery from "../components/ImageGallery";
import Block2Columns from "../components/Block2ColumnsText";
import BannerGeneral from "../components/BannerGeneral";
function UtplSostenible() {
  const DataDisplay = ({ data }) => (
    <>
      <>
        {data.map((item, index) => (
          <>
            <div className="utpl-sostenible">
              <BlockImageCabecera
                src={item.field_portada}
                title={
                  <>
                    <center>
                      <div
                        className="fontsize14"
                        dangerouslySetInnerHTML={{
                          __html: item.field_texto_portada,
                        }}
                      />
                    </center>
                    <div className="icon150 ">
                      <img src={item.field_imagen1}></img>
                    </div>
                  </>
                }
              ></BlockImageCabecera>
            </div>
            <div className="utpl-sostenible">
              <BlockBackgroundImage
                src={item.field_imagen2}
                content={
                  <>
                    <div
                      className="fontsize14"
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque2,
                      }}
                    />
                  </>
                }
              ></BlockBackgroundImage>
            </div>
            <div
              className="fontsize14 layout6  padding"
              dangerouslySetInnerHTML={{
                __html: item.field_bloque3,
              }}
            />
            <div className="lightbluebg padding">
              <div className="layout8 utpl-sostenible">
                <center>
                  <p className="iconsize20">💧🌞</p>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque4,
                    }}
                  />
                </center>
              </div>
              <center>
                <div className="margin icontextsize">
                  <Block3Columns
                    col1={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen5} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque5,
                          }}
                        />
                      </>
                    }
                    col2={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen6} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque6,
                          }}
                        />
                      </>
                    }
                    col3={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen7} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque7,
                          }}
                        />
                      </>
                    }
                  ></Block3Columns>
                </div>

                <div className="margin icontextsize">
                  <Block3Columns
                    col1={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen8} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque8,
                          }}
                        />
                      </>
                    }
                    col2={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen9} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque9,
                          }}
                        />
                      </>
                    }
                    col3={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen10} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque10,
                          }}
                        />
                      </>
                    }
                  ></Block3Columns>
                </div>
              </center>
              <div className="layout8 margin">
                <ImageGallery gallery={item.field_gallery1}></ImageGallery>
              </div>
            </div>
            <div className="utpl-sostenible bg-sostenible padding">
              <div className="layout8">
                <p className="iconsize20">📚✨</p>
                <div
                  className=" fontsize14 width600"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque11,
                  }}
                />
              </div>
              <center>
                <div className="margin icontextsize">
                  <Block3Columns
                    col1={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen12} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque12,
                          }}
                        />
                      </>
                    }
                    col2={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen13} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque13,
                          }}
                        />
                      </>
                    }
                    col3={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen14} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque14,
                          }}
                        />
                      </>
                    }
                  ></Block3Columns>
                </div>

                <div className="margin icontextsize">
                  <Block3Columns
                    col1={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen15} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque15,
                          }}
                        />
                      </>
                    }
                    col2={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen16} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque16,
                          }}
                        />
                      </>
                    }
                    col3={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen17} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque17,
                          }}
                        />
                      </>
                    }
                  ></Block3Columns>
                </div>
              </center>
            </div>

            <div
              className="layout6 fontsize14 padding "
              dangerouslySetInnerHTML={{
                __html: item.field_bloque18,
              }}
            />

            <div className="lightbluebg padding utpl-sostenible">
              <div className="layout8">
                {" "}
                <p className="iconsize20">🌱📘</p>
                <div
                  className="width600"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque19,
                  }}
                />
              </div>

              <Block2Columns
                col1={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque20,
                      }}
                    />
                  </>
                }
                col2={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque21,
                      }}
                    />
                  </>
                }
              ></Block2Columns>
            </div>
          </>
        ))}
      </>
    </>
  );

  const DataDisplay2 = ({ data }) => (
    <>
      <>
        {data.map((item, index) => (
          <>
            <div className=" utpl-sostenible bg-sostenible padding">
              <div className="layout8">
                <center>
                  <p className="iconsize20">🎓🌍</p>
                  <div
                    className="width700  "
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque1,
                    }}
                  />
                </center>
              </div>

              <Block2Columns
                col1={
                  <>
                    <img src={item.field_imagen2}></img>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque2,
                      }}
                    />
                  </>
                }
                col2={
                  <>
                    <img src={item.field_imagen3}></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque3,
                      }}
                    />
                  </>
                }
              ></Block2Columns>
              <div className="layout8">
                <center>
                  <a
                    className="button margin"
                    href="https://catedrasunesco.utpl.edu.ec/desarrollo-sostenible"
                  >
                    {" "}
                    Más información
                  </a>
                </center>
              </div>
            </div>

            <div className="lightblubg padding">
              <div className="layout8 utpl-sostenible">
                <center>
                  <p className="iconsize20">🔬✨</p>
                  <div
                    className="fontsize14  width600"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque4,
                    }}
                  />
                </center>
              </div>

              <center>
                <div className=" margin utpl-sostenible">
                  <div className="icontextsize">
                    {" "}
                    <Block4Columns
                      col1={
                        <>
                          <div className="icon50">
                            <img src={item.field_imagen5} alt="utpl"></img>
                          </div>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.field_bloque5,
                            }}
                          />
                        </>
                      }
                      col2={
                        <>
                          <div className="icon50">
                            <img src={item.field_imagen6} alt="utpl"></img>
                          </div>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.field_bloque6,
                            }}
                          />
                        </>
                      }
                      col3={
                        <>
                          <div className="icon50">
                            <img src={item.field_imagen7} alt="utpl"></img>
                          </div>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.field_bloque7,
                            }}
                          />
                        </>
                      }
                      col4={
                        <>
                          <div className="icon50">
                            <img src={item.field_imagen8} alt="utpl"></img>
                          </div>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.field_bloque8,
                            }}
                          />
                        </>
                      }
                    ></Block4Columns>
                  </div>

                  <div className="padding">
                    <h4>
                      Proyectos <b>emblemáticos</b>
                    </h4>

                    <Block3Columns
                      col1={
                        <>
                          {" "}
                          <div className="icon150">
                            <img src={item.field_imagen9} alt="utpl"></img>
                          </div>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.field_bloque9,
                            }}
                          />
                        </>
                      }
                      col2={
                        <div className="margin">
                          {" "}
                          <div className="icon150">
                            <img src={item.field_imagen10} alt="utpl"></img>
                          </div>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.field_bloque10,
                            }}
                          />
                        </div>
                      }
                      col3={
                        <>
                          {" "}
                          <div className="icon150">
                            <img src={item.field_imagen11} alt="utpl"></img>
                          </div>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.field_bloque11,
                            }}
                          />
                        </>
                      }
                    ></Block3Columns>
                  </div>
                </div>
              </center>
            </div>

            <div className="utpl-sostenible bg-sostenible padding">
              <div className="layout8">
                <p className="iconsize20">🤝📚</p>
                <div
                  className="fontsize14  width600"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque12,
                  }}
                />
              </div>
              <div className="icontextsize margin">
                <center>
                  <Block4Columns
                    col1={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen13} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque13,
                          }}
                        />
                      </>
                    }
                    col2={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen14} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque14,
                          }}
                        />
                      </>
                    }
                    col3={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen15} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque15,
                          }}
                        />
                      </>
                    }
                    col4={
                      <>
                        <div className="icon50">
                          <img src={item.field_imagen16} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque16,
                          }}
                        />
                      </>
                    }
                  ></Block4Columns>
                </center>
              </div>

              <div className="layout8 margin">
                {" "}
                <center>
                  {" "}
                  <h4>
                    Proyectos <b>emblemáticos</b>
                  </h4>
                </center>
              </div>
              <br></br>

              <Block2Columns
                col1={
                  <>
                    <img src={item.field_imagen17} alt="utpl"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque17,
                      }}
                    />
                  </>
                }
                col2={
                  <>
                    <img src={item.field_imagen18} alt="utpl"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque18,
                      }}
                    />
                  </>
                }
              >
                {" "}
              </Block2Columns>

              <div className="margin">
                <Block2Columns
                  col1={
                    <>
                      <img src={item.field_imagen19} alt="utpl"></img>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque19,
                        }}
                      />
                    </>
                  }
                  col2={
                    <>
                      <img src={item.field_imagen20} alt="utpl"></img>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque20,
                        }}
                      />
                    </>
                  }
                >
                  {" "}
                </Block2Columns>
              </div>
            </div>
            <div  className="utpl-sostenible"> 
            <BlockBackgroundImage 
              src={item.field_portada}
              content={
                <>
                  {" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />{" "}
                </>
              }
            ></BlockBackgroundImage></div>
            <div className="padding layout8">
              <p className="iconsize20">🌱 </p>
              <div
                className="  width600"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque21,
                }}
              />
            </div>
          </>
        ))}
      </>
    </>
  );
  return (
    <>
      {" "}
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/utpl-sostenible.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/utpl-sostenible-2.json">
        {(data) => <DataDisplay2 data={data} />}
      </DataFetcherTemplate>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default UtplSostenible;
